import { render } from "./PricesManagerSettingsList.vue?vue&type=template&id=77fbf3d4&scoped=true"
import script from "./PricesManagerSettingsList.vue?vue&type=script&lang=js"
export * from "./PricesManagerSettingsList.vue?vue&type=script&lang=js"

import "./PricesManagerSettingsList.vue?vue&type=style&index=0&id=77fbf3d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fbf3d4"]])

export default __exports__